require("!!/home/jormat/jormat-front/node_modules/script-loader/addScript.js")(require("!!/home/jormat/jormat-front/node_modules/raw-loader/index.js!/home/jormat/jormat-front/bower_components/highcharts-ng/dist/highcharts-ng.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/highcharts-ng/dist/highcharts-ng.js
// module id = 528
// module chunks = 0